import img1 from '/static/img/experience/services/bodyguardServices/img1.png'
import img2 from '/static/img/experience/services/bodyguardServices/img2.png'
import img3 from '/static/img/experience/services/bodyguardServices/img3.png'
import img4 from '/static/img/experience/services/bodyguardServices/img4.png'
const bodyguardServicesInfo = {
    title:'bodyguard services',
    desc:'We provide private bodyguards, family bodyguards, and business bodyguards.',
    list:[
        {
            id:1,
            img:img1,
            itemList:[
                {
                    id:1,
                    title:'Private Bodyguard Services',
                    desc:'We provide 24-hour personal protection for individuals during daily travel, business activities, or social gatherings to ensure the safety of our clients.',
                },
                {
                    id:2,
                    title:'Family Bodyguard',
                    desc:'Escorting children on outings, accompanying family members on outings, etc., providing safety precautions, and creating a safe living environment.',
                },
                {
                    id:3,
                    title:'Business Bodyguard',
                    desc:'Provides professional security protection for business people participating in important meetings and other activities to ensure that business activities proceed smoothly and avoid losses due to security issues.',
                }
            ]
        },
        {
            id:2,
            img:img2,
            title:'medical care',
            itemList:[
                {
                    id:1,
                    desc:'Professional doctors accompany you throughout your trip.',
                },
                {
                    id:2,
                    desc:'Respond to emergencies, pay attention to dietary health, and ensure safety.',
                },
                {
                    id:3,
                    desc:'Top medical institutions\' VIP emergency channels are available 24 hours a day.',
                }
            ]
        },
        {
            id:3,
            img:img3,
            title:'Travel Companion',
            itemList:[
                {
                    id:1,
                    desc:'Professional travel concierge service throughout your trip.',
                },
                {
                    id:2,
                    desc:'Professional tour guides accompany you and your family on your trip.',
                },
                {
                    id:3,
                    desc:'Customized personal service.',
                }
            ]
        },
        {
            id:4,
            img:img4,
            title:'Photography services',
            itemList:[
                {
                    id:1,
                    desc:'Photography services',
                },
                {
                    id:2,
                    desc:'Customized photography appointments with excellent photographers',
                }
            ]
        },
    ]
}
export default {
    bodyguardServicesInfo
}